import React, { FC, Suspense, useCallback, useEffect, useMemo } from 'react'
import { Router, Route, Switch, Redirect, useLocation } from 'react-router-dom'
import createHashHistory from 'history/createHashHistory'
import { jumpToUCOpenservice } from 'src/utils/function'

import routes, { getAuthMenu, noAuthRoutes } from './routes'
import Loading from './Loading'

const history = createHashHistory()
const prefix = '/sdwan'

interface PagesProps {
  getPathname: (pathname: string) => void
  hasAuth: boolean
}

const Pages: FC<PagesProps> = (props) => {
  const pathname = useLocation().pathname

  useEffect(() => {
    props.getPathname(pathname)
  }, [pathname, props.getPathname])

  const routeRender = useCallback(() => {
    if(props.hasAuth) {
      return <Redirect to={`${prefix}/dashboard/overview`} />
    } else {
      const isComplete = process.env.REACT_APP_IS_COMPLETE === 'true' || (process.env.NODE_ENV === 'development' && process.env.REACT_APP_IS_DEBUG === 'false')
      if(isComplete) {
        return <Redirect to={`${prefix}/openService`} />
      } else {
        // 接入统一平台
        jumpToUCOpenservice()
      }
    }
  }, [props.hasAuth])

  const routesItems = useMemo(() => {
    return props.hasAuth ? getAuthMenu(routes) : noAuthRoutes
  }, [props.hasAuth])

  return (
    <div className="pages sd-wan">
      <Router history={history}>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path={prefix} render={routeRender} />

            {routesItems.map(item => (
              <Route
                exact
                key={item.key}
                path={prefix + item.path}
                component={item.component}
              />
            ))}

            {/* <Route
              key={'404'}
              path={'*'}
              component={PageNotFound}
            /> */}
          </Switch>
        </Suspense>
      </Router>
    </div>
  )
}

export default Pages